/**
 * Shared measurements between the tutor's input bar and its transcript line (owner round 14.2: "questions are overlaying
 * the tutor's spoken words"): the input bar reports how tall its suggestion row is, and the transcript line sits above it.
 */
let chipsHeight = 0;
const listeners = new Set();
export function setChipsHeight(height) {
  const next = Math.max(0, Math.round(height || 0));
  if (next === chipsHeight) return;
  chipsHeight = next;
  listeners.forEach(fn => fn(chipsHeight));
}
export function onChipsHeight(fn) {
  listeners.add(fn);
  fn(chipsHeight);
  return () => listeners.delete(fn);
}
